import { render, staticRenderFns } from "./OrganisationMain.vue?vue&type=template&id=37516c65&scoped=true"
import script from "./OrganisationMain.vue?vue&type=script&lang=ts"
export * from "./OrganisationMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37516c65",
  null
  
)

export default component.exports